import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { HttpLink } from 'apollo-link-http'

const DEFAULT_SUBGRAPH_URI =
  'https://api.goldsky.com/api/public/project_cmgzm21qo008x5np27bk21873/subgraphs/ixs/crooked_jade_marten/gn'
const DEFAULT_BLOCKS_URI =
  'https://api.goldsky.com/api/public/project_cl8ylkiw00krx0hvza0qw17vn/subgraphs/blocks/matic/gn'

export const client = new ApolloClient({
  link: new HttpLink({
    uri: process.env.REACT_APP_SUBGRAPH_URI || DEFAULT_SUBGRAPH_URI,
  }),
  cache: new InMemoryCache(),
  shouldBatch: true,
})

export const healthClient = new ApolloClient({
  link: new HttpLink({
    uri: 'https://api.thegraph.com/index-node/graphql',
  }),
  cache: new InMemoryCache(),
  shouldBatch: true,
})

export const stakingClient = new ApolloClient({
  link: new HttpLink({
    uri: 'https://api.thegraph.com/subgraphs/name/way2rach/talisman',
  }),
  cache: new InMemoryCache(),
  shouldBatch: true,
})

export const blockClient = new ApolloClient({
  link: new HttpLink({
    uri: process.env.REACT_APP_BLOCKS_SUBGRAPH_URI || DEFAULT_BLOCKS_URI,
  }),
  cache: new InMemoryCache(),
})
